// Modelo Vacuna para administrador.
export default class Vaccine {
    id=""
    name=""
    duration=""
    group=""
}



// WEBPACK FOOTER //
// ./src/model/Vaccine.js